import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import {
  View, Paragraph, Block, CoreLink,
} from '@uncinc/react-drupal-core';
import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity, ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { TaxonomyThemes } from '../../../../types/uncinc_profile/taxonomy';
import { BLOCK_NEWSLETTER_BLOCK_ID } from '../../../../config/constants';
import { getOverviewUrlFromMenu } from '../../../../helpers';

import './style.scss';

interface TaxonomyThemeParentPageProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<TaxonomyThemes>;
}

const TaxonomyThemeParentPage: React.FC<TaxonomyThemeParentPageProps> = ({ entity }) => {
  const classes = classNames('TaxonomyThemeParentPage');
  const theme = entity.toJS();
  const id = theme.tid[0].value;
  const name = theme.name[0].value;
  const paragraphs = theme.field_paragraphs;
  const description = theme.description[0].value;

  const lastBreadcrumbTitle = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['entity', 'breadcrumbs', 1, 'title']));
  const lastBreadcrumbUrl = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['entity', 'breadcrumbs', 1, 'url']));

  const menu = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['menu', 'main']));
  const overviewUrl = getOverviewUrlFromMenu(menu, 'themes');

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>

      <Container>
        <div className="row">
          <div className="col-12">
            <ol className="Breadcrumbs" vocab="https://schema.org/" typeof="BreadcrumbList">
              <li className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
                <CoreLink href="/">Home</CoreLink>
              </li>
              <li className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
                <CoreLink href={overviewUrl}>Onze thema&#39;s</CoreLink>
              </li>
              {lastBreadcrumbTitle && lastBreadcrumbUrl && (
                <li className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
                  <CoreLink href={lastBreadcrumbUrl}>{lastBreadcrumbTitle}</CoreLink>
                </li>
              )}
              <li className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
                <span>{name}</span>
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-11 col-lg-8 offset-lg-2">
            <div className="TaxonomyThemeParentPage__title">
              <h1>{name}</h1>
            </div>
            <div className="TaxonomyThemeParentPage__body">
              <WysiwygField html={description} />
            </div>
          </div>
        </div>

        <div className="TaxonomyThemeParentPage__dossiers items-container">
          <View
            id="theme"
            display="by_parent"
            args={[id]}
          />
        </div>
      </Container>

      <div className="TaxonomyThemeParentPage__paragraphs">
        {paragraphs.map((paragraph) => {
          const paragraphId = paragraph.target_id;
          const language = paragraph.entity.langcode[0].value;
          return (
            <Paragraph
              key={`paragraph:${paragraphId}:${language}`}
              entity={Immutable.fromJS(paragraph.entity)}
            />
          );
        })}
      </div>

      {/* Newsletter block */}
      <Block
        id={BLOCK_NEWSLETTER_BLOCK_ID}
      />

    </article>
  );
};

export default TaxonomyThemeParentPage;
